import ErrorState from '@rio-cloud/rio-uikit/ErrorState';
import { FormattedMessage } from 'react-intl';

import { GenericErrorWrapper } from './GenericError.style';

const GenericError = ({ message }: { message?: string }) => (
  <GenericErrorWrapper>
    <ErrorState
    headline={<FormattedMessage id="common.error" />}
    message={<FormattedMessage id={message || 'common.genericError.message'} />}
    buttons={[{  text: <FormattedMessage id="common.refresh" />, onClick: () => window.location.href = '/' }]}
  />
  </GenericErrorWrapper>
);

export default GenericError;
